import { HasId } from './edit/HasId';
import { FilterResult } from './repository.service';
import { WancomHttpService } from '../../services/wancom-http/wancom-http.service';
import { BehaviorSubject, from } from 'rxjs';
import { StorageService } from '../../services/storage/storage.service';
import { AppStateService } from '../../services/appState/app-state.service';

const valuesCache: { [key: string]: FilterResult<EnumItem> } = {};

export class EnumRepositoryService extends BehaviorSubject<FilterResult<EnumItem>> {
	constructor(
		protected http: WancomHttpService,
		protected url: string,
		protected OFFLINE_STORAGE_KEY = null,
		protected appStateService: AppStateService = null,
		protected storageService: StorageService = null
	) {
		super({ items: [], total: 0 });
	}

	getEnumPromise(): Promise<FilterResult<EnumItem>> {
		return new Promise((resolve, reject) => {
			const url = this.url;
			if (!valuesCache[url]) {
				const call = this.http.post<FilterResult<EnumItem>>(url, {});
				call.subscribe((result) => {
					valuesCache[url] = result;
					resolve(result);
				});
			} else {
				resolve(valuesCache[url]);
			}
		});
	}

	async getEnumPromiseAsync(): Promise<FilterResult<EnumItem>> {
		if (this.OFFLINE_STORAGE_KEY && (await this.appStateService.isOfflineMode())) {
			return this.getEnumOffline();
		} else {
			return this.getEnumPromise();
		}
	}

	getEnum() {
		const call = from(this.getEnumAsync());
		call.subscribe((result) => {
			this.next(result);
		});
		return call;
	}

	async getEnumAsync() {
		if (this.OFFLINE_STORAGE_KEY && (await this.appStateService.isOfflineMode())) {
			return this.getEnumOffline();
		} else {
			return this.getEnumOnline().toPromise();
		}
	}

	getEnumOnline() {
		const url = this.url;
		if (!valuesCache[url]) {
			const call = this.http.post<FilterResult<EnumItem>>(url, {});
			call.subscribe((result) => {
				valuesCache[url] = result;
				this.next(result);
			});
		} else {
			this.next(valuesCache[url]);
		}

		return this;
	}

	async getEnumOffline() {
		const items = await this.storageService.getItem<FilterResult<EnumItem>>(this.OFFLINE_STORAGE_KEY);
		return items;
	}

	async downloadOffline() {
		const res = await this.http.post<FilterResult<EnumItem>>(this.url, {}).toPromise();
		this.storageService.setItem(this.OFFLINE_STORAGE_KEY, res);
	}
}

export interface EnumItem extends HasId {
	name: string;
	translationKey: string;
	translation?: string;
}
